"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @description Scans document for css variables defined at `:root`.
 * Because library assumes consumer may be using [IE11 Custom Properties](https://github.com/nuxodin/ie11CustomProperties) polyfill,
 * this function will catch  css variables with prefix `-ie-` and return those variable names with standard css variable prefix  `--`.
 *
 * If `-ie-primary` is found in document styles, this function will translate to `--primary` and include in result array.
 *
 * @return {string[]} Array of css variable names, example: ['--primary', '--secondary']
 */
function default_1() {
    // Look through all cssStyleRules in document.styleSheets
    const cssVariableNames = Array.from(document.styleSheets)
        .filter(styleSheet => styleSheet.href === null || styleSheet.href.startsWith(window.location.origin))
        .flatMap(styleSheet => Array.from(styleSheet.cssRules))
        .filter(cssRule => cssRule.selectorText === ':root')
        .flatMap(cssRule => _getCssRulePropertiesListFromCssText(cssRule.cssText))
        .filter(name => name.startsWith('--')); // css variables are identified by standard `--` prefix
    return cssVariableNames;
}
exports.default = default_1;
/** @description Extracts css property names from css rule.
 *
 * @param {string} cssRuleText Text in format of: `selector { property: value; property: value; }`
 *
 * @return {string[]} Array of css rule properties, example: ['--primary', '--secondary', 'height', 'width']
 */
function _getCssRulePropertiesListFromCssText(cssRuleText) {
    return cssRuleText
        .split('{')[1] // remove start text `selector {`
        .split('}')[0] // remove end text `}`
        .split(';') // split into array of cssRuleProperties, format ['property: value', ...]
        .map(style => style
        .split(':')[0] // get property only, we don't care about value
        .trim()
        .replace('-ie-', '--') // treat IE11 Custom Properties polyfill values as standard css variables
    );
}
//# sourceMappingURL=ScanDocumentForCssVariableNames.js.map